/** 与布局断点一致：≤768px 视为移动端（见 App.vue、各视图 @media） */
export const MOBILE_BREAKPOINT_MAX_PX = 768

/** 管理端列表页：大屏默认表格列表，移动端默认卡片网格 */
export function defaultAdminListViewMode() {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return 'list'
  return window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT_MAX_PX}px)`).matches ? 'grid' : 'list'
}

function resolveApiRoot() {
  const raw = process.env.VUE_APP_API_URL || ''
  const url = String(raw).trim().replace(/^["']|["']$/g, '')
  return (url || 'http://localhost:8090').replace(/\/$/, '')
}

/**
 * 将数据库中的图片路径转为可访问 URL（相对路径 /uploads/... 拼 API 根地址）
 */
export function resolveMediaUrl(path) {
  if (path == null || path === '') return ''
  const s = String(path).trim()
  if (s.startsWith('http://') || s.startsWith('https://') || s.startsWith('data:')) return s
  const base = resolveApiRoot()
  return s.startsWith('/') ? `${base}${s}` : `${base}/${s}`
}

/** 器材列表/卡片用封面：优先 imageUrl，否则按名称尝试静态目录默认图 */
export function equipmentCoverUrl(item) {
  if (!item) return ''
  if (item.imageUrl) return resolveMediaUrl(item.imageUrl)
  if (item.name) return resolveMediaUrl(`/uploads/equipment/${item.name}.png`)
  return ''
}
